// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6ce477d8","453":"668705ac","732":"ce97d028","762":"5396d994","977":"40869ae0"}[chunkId] + ".chunk.js";
};